import React from 'react';
import Modal from '../../Components/Modal/Modal';
import ConfirmButton from '../../Components/Buttons/ConfirmButton';
import CancelButton from '../../Components/Buttons/CancelButton';

function TermsAndConditionsCollege(props) {
  return (
    <Modal
      id='terms-co-box'
      header='EDUCATION PROVIDER Terms & Conditions'
      onClose={props.onClose}
      show={props.show}
    >
      <p className='terms-co-box-subtitle'>
        ReadyTeacher provides the ReadyTeacher digital recruitment platform that
        connects registered teaching and training providers and with specialist
        education professionals.
      </p>
      <ol>
        <h4>
          <li>
            <strong>TERMS AND CONDITIONS OF USE & PLATFORM LICENCE</strong>
          </li>
        </h4>
        <p>
          <ol>
            <li>
              ReadyTeacher Services include (without limitation):
              <ol>
                <li>
                  Arranging the placement of an{' '}
                  <strong>Education Professional</strong> for the{' '}
                  <strong>Education Provider</strong>, at such locations as the
                  Education Provider may direct, including Online (Remote)
                  locations <strong>(Placement)</strong>; and
                </li>
                <li>
                  A <strong>Licence</strong> for the Education Provider to
                  access and use ReadyTeacher’s proprietary online platform{' '}
                  <strong>(Platform)</strong>.
                </li>
              </ol>
            </li>
            <li>
              The parties agree that all ReadyTeacher Services provided by
              ReadyTeacher to the Education Provider are subject to the terms of
              this Agreement.
            </li>
            <li>
              This Agreement shall apply to each Placement, and the Licence
              granted to the Education Provider for use of the Platform.
            </li>
            <li>
              Whereby there is an occurrence of late payment by the Education
              Provider (Customer), or failure to pay for services rendered or
              Platform access, ReadyTeacher reserves the right to terminate this
              Agreement.
            </li>
            <li>
              ReadyTeacher provides the Education Provider with a non-exclusive
              licence to use the features of the Platform associated with an
              Education Provider account for the duration of the Term of this
              Agreement (Licence).
            </li>
            <li>
              The Education Provider must register as an Education Provider on
              the Platform in order to use the Licence.
            </li>
            <li>
              The Education Provider is responsible for each user that it
              authorises to access the Education Provider’s account within the
              Platform (Authorised User).
            </li>
            <li>
              ReadyTeacher may immediately terminate this agreement in the event
              that;
              <ol>
                <li>
                  The Education Provider is disqualified from providing
                  education services by:
                  <ol>
                    <li className='tc-roman-li2'>
                      Australian Skills Quality Authority in Australia; and
                    </li>
                    <li className='tc-roman-li2'>
                      The Department of Education in Australia; or
                    </li>
                    <li className='tc-roman-li2'>
                      Relevant or equivalent governing bodies in the region or
                      country in which the Education Provider is a registered
                      business and registers for the Platform; and
                    </li>
                    <li className='tc-roman-li2'>
                      Any other Government or regulatory body with the power to
                      disqualify an Education Provider.
                    </li>
                  </ol>
                </li>
                <li>
                  The Education Provider is repeatedly late in settling payment
                  for services provided.
                </li>
                <li>
                  The Education Provider behaves towards ReadyTeacher Education
                  Professionals (Employees and/or Contractors) in a manner that
                  reflects Workplace Discrimination (as per the Equal
                  Opportunity Act 2010) or unfair treatment of any kind. This
                  includes discrimination towards Education Professionals who
                  are non-native speakers of English.
                </li>
              </ol>
            </li>
          </ol>
        </p>
        <h4>
          <li>
            <strong>CONFIDENTIALITY</strong>
          </li>
        </h4>
        <p>
          <ol>
            <li>
              Each party and representative of Education Providers will keep all
              Confidential Information in confidence on an ongoing basis, in
              accordance with the General Conditions.
            </li>
            <li>
              The Education Provider must keep any information provided by
              ReadyTeacher about an Education Professional confidential.
            </li>
          </ol>
        </p>
        <h4>
          <li>
            <strong>PROVIDING EDUCATION PROFESSIONALS</strong>
          </li>
        </h4>
        <p>
          <ol>
            <li>
              The Education Provider may book an Education Professional for
              Placement by either:
              <ol>
                <li>Using the Platform; or</li>
                <li>
                  Using the <strong>Mobile Application</strong> (where available).
                </li>
              </ol>
            </li>
            <li>
              The Education Provider must supply ReadyTeacher with the necessary
              details in order to request a Placement, which may include
              (without limitation):
              <ol>
                <li>
                  The address of the campus or other location where the
                  Education Professional is to attend the Placement{' '}
                  <strong>(Location)</strong>;
                </li>
                <li>The duration that the Placement is intended to last;</li>
                <li>
                  The time that the Education Professional must be at the
                  Location each day of the Placement;
                </li>
                <li>
                  The time that the Education Professional may leave the
                  Location each day of the Placement;
                </li>
                <li>
                  The identity of their preferred Education Professional for the
                  Placement (if any);
                </li>
                <li>
                  The classes or courses that the Education Professional will be
                  expected to teach during the Placement;
                </li>
                <li>
                  The minimum qualifications and experience the Education
                  Professional must have to teach the Placement;
                </li>
                <li>
                  Any policies and guidelines that the Education Professional
                  must comply with as part of the Placement (including dress
                  code, if any);
                </li>
                <li>Any special requirements relative to the Placement; and</li>
                <li>
                  Such other information that ReadyTeacher may reasonably
                  require.
                </li>
              </ol>
            </li>
            <li>
              A Placement is not confirmed until ReadyTeacher notifies the
              Education Provider of the confirmation email event invitation.
              <ol>
                <li>
                  A confirmation of a Placement shall include details of:
                  <ol>
                    <li className='tc-roman-li2'>
                      The name of the Education Professional;
                    </li>
                    <li className='tc-roman-li2'>
                      The qualifications and experience of the Education
                      Professional (<strong>Profile</strong> and{' '}
                      <strong>Resume</strong>);
                    </li>
                    <li className='tc-roman-li2'>
                      The <strong>Billable Hours</strong> that shall apply to
                      the Placement; and
                    </li>
                    <li className='tc-roman-li2'>
                      ReadyTeacher is under no obligation to confirm a Booking
                      that is received outside reasonable travel time, and the
                      Education Provider will not be charged for any Placement
                      that does not occur.
                    </li>
                  </ol>
                </li>
                <li>
                  ReadyTeacher shall make best endeavours to supply the
                  Education Provider with their preferred Education
                  Professional, but is under no obligation to do so.
                </li>
                <li>
                  Subject to the Education Provider’s approval, ReadyTeacher
                  shall supply the Education Provider with an alternative
                  Education Professional that has informed ReadyTeacher that
                  they are suitably qualified to teach the same classes or
                  courses in the event that:
                  <ol>
                    <li className='tc-roman-li2'>
                      The requested Education Professional is unavailable at the
                      commencement of the Placement; or
                    </li>
                    <li className='tc-roman-li2'>
                      The Education Professional that is subject to a Placement
                      is unavailable at any time during the Placement.
                    </li>
                  </ol>
                </li>
                <li>
                  Once a Booking is confirmed, ReadyTeacher shall arrange for
                  the Education Professional to attend the Location.
                </li>
                <li>
                  The Education Provider shall maintain the Placement for the
                  duration confirmed with ReadyTeacher prior to Commencement,
                  unless cancelled in accordance with this Agreement.
                </li>
              </ol>
            </li>
            <li>
              The Education Provider may communicate via the ReadyTeacher{' '}
              <strong>Application chat function</strong> with each
              Education Professional once a Placement has been confirmed, or by email where possible.
            </li>
            <li>
              Once the Placement is confirmed the Education Provider must make
              best endeavours to provide the Education Professional with any
              learning materials and specific lesson instructions via the ReadyTeacher
              Application chat function, or by email where possible.
            </li>
            <li>Re-booking must occur via ReadyTeacher.</li>
          </ol>
        </p>
        <h4>
          <li>
            <strong>RELATIONSHIP WITH EDUCATION PROFESSIONALS</strong>
          </li>
        </h4>
        <p>
          <ol>
            <li>
              The Education Provider agrees and acknowledges that:
              <ol>
                <li>
                  The Education Provider must pay ReadyTeacher for any services
                  that the Education Professional performs for the Education
                  Provider.
                </li>
                <li>
                  The Education Professional must not be paid directly outside
                  of ReadyTeacher.
                </li>
                <li>
                  Each Education Professional subject to a Placement, and the
                  Education Provider, are directly responsible to each other.
                  While all care is taken, ReadyTeacher cannot warrant the
                  qualifications or experience represented by the Education
                  Professional to either the Education Provider or ReadyTeacher.
                </li>
              </ol>
            </li>
            <li>
              ReadyTeacher shall not be responsible for the conduct of any
              Education Professional in relation to a Placement, including
              without limitation for any:
              <ol>
                <li className='tc-roman-li2'>
                  Misconduct that would normally result in the suspension of a
                  staff member or contractor’s engagement with the Education
                  Provider;
                </li>
                <li className='tc-roman-li2'>
                  Offence committed by the Education Professional;
                </li>
                <li className='tc-roman-li2'>
                  Damage to the property of the Education Provider or any
                  third-party;
                </li>
                <li className='tc-roman-li2'>
                  Personal injury or death caused to any person; or
                </li>
                <li className='tc-roman-li2'>
                  Consequential loss of any kind.
                </li>
              </ol>
            </li>
            <li>
              The Education Provider should submit a complaint to ReadyTeacher
              via its Complaints Policy process in the event that the conduct of
              the Education Professional causes concern to any member of staff
              or student at the Education Provider’s physical or virtual
              classroom.
            </li>
            <li>
              Notwithstanding the Education Provider’s other obligations under
              this Agreement, the Education Provider may exclude an Education
              Professional from its premises at its discretion, notifying
              ReadyTeacher immediately.
            </li>
            <li>
              The Education Provider shall not contract directly with an
              Education Professional for the Education Professional to provide
              services to the Education Provider, and the Education Provider
              must not pay the Education Professional directly, unless
              specifically agreed otherwise by ReadyTeacher in accordance with
              this Agreement.
            </li>
            <li>
              The Education Provider is responsible for providing the Education
              Professional with all lesson plans, learning outcomes and assessment
              materials.
            </li>
            <li>
              The Education Professional shall not be required by the Education
              Provider to mark any assessments outside of the hours that the
              Education Professional provides services subject to a Placement,
              without claiming payment of non-teaching hours.
            </li>
            <li>
              The Education Provider must treat each Education Professional with
              professionalism and respect during a Placement. In no circumstance
              shall the Education Provider discriminate against an Education
              Professional on racial, gender or religious grounds.
            </li>
          </ol>
        </p>
        <h4>
          <li>
            <strong>PLACEMENT TYPES</strong>
          </li>
        </h4>
        <p>
          <ol>
            <li>
              ReadyTeacher arranges following types of Placement subject to the
              terms of this Agreement:
              <ol>
                <li className='tc-roman-li2'>
                  Emergency Placement (<strong>item 5.2</strong>);
                </li>
                <li className='tc-roman-li2'>
                  Extended Placement (<strong>item 5.3</strong>);
                </li>
                <li className='tc-roman-li2'>
                  Employee Trial Period (FET), (
                  <strong>item 5.4</strong>).
                </li>
              </ol>
            </li>
            <li>
              Emergency Placement
              <ol>
                <li>
                  A Education Provider may book an Education Professional for a
                  Placement on short notice (
                  <strong>Emergency Placement</strong>) on the terms of this
                  Agreement.
                </li>
                <li>
                  Refer to ReadyTeacher’s Services Agreement for all related details including terms and fees.
                </li>
              </ol>
            </li>
            <li>
              Extended placement
              <ol>
                <li>
                  An Education Provider may book a Placement that is scheduled
                  to last a period of between two days and 6 months (negotiable)
                  in duration (<strong>Extended Placement</strong>) on the terms
                  of this Agreement.
                </li>
                <li>
                  Refer to ReadyTeacher’s Services Agreement for all related details including terms and fees.
                </li>
              </ol>
            </li>
            <li>
              Employee Trial Period
              <ol>
                <li>
                  In the event the Education Provider wishes to directly
                  employee an Education Professional, the Education Provider may
                  do so by:
                  <ol>
                    <li className='tc-roman-li2'>
                      Requesting an{' '}
                      <strong>Employee Trial Period</strong> of
                      minimum 130 hours to maximum 180 hours hours, unless otherwise
                      negotiated with ReadyTeacher and the Education
                      Professional; and
                    </li>
                    <li className='tc-roman-li2'>
                      Requesting to interview candidates where the Education
                      Professional is not specifically requested by the
                      Education Provider.
                    </li>
                  </ol>
                </li>
                <li>
                  Refer to ReadyTeacher’s Services Agreement for all related details including terms and fees.
                </li>
                <li>
                  ReadyTeacher, the Education Provider and the Education
                  Professional may withdraw from the Employee Trial Period at
                  any time throughout the trial without incurring penalty, if the
                  basis of withdrawal reflects;
                  <ol start='4'>
                    <li className='tc-roman-li2'>
                      Mismatched skills or personality of the Education
                      Professional;
                    </li>
                    <li className='tc-roman-li2'>
                      Problems between the Education Professional and the
                      Education Provider (Staff or Students);
                    </li>
                    <li className='tc-roman-li2'>
                      Inappropriate conduct by the Education Provider or
                      Education Professional.
                    </li>
                  </ol>
                </li>
              </ol>
            </li>
          </ol>
        </p>
        <h4>
          <li>
            <strong>EXCLUSIVITY</strong>
          </li>
        </h4>
        <p>
          <ol>
            <li>
              In the event that the Education Provider wishes to directly engage the services of
              the Educator (employ the educator directly) at any time following the end of
              the Educator’s last Placement with the Education Provider, the Education Provider
              must exclusively do so by completing an Employee Trial Period with ReadyTeacher
              on the terms of this Agreement.
            </li>
          </ol>
        </p>
        <h4>
          <li>
            <strong>BOOKING CANCELLATION</strong>
          </li>
        </h4>
        <p>
          <ol>
            <li>
              The Education Provider shall maintain a Placement for the duration
              confirmed with ReadyTeacher. Refer to ReadyTeacher’s Services Agreement for
              all related details including terms and fees.
            </li>
          </ol>
        </p>
        <h4>
          <li>
            <strong>FEES & PAYMENT</strong>
          </li>
        </h4>
        <p>
          <ol>
            <li>
              The <strong>Education Professional’s Rate (ELICOS rate)</strong> for English
              Language Teachers in Australia as at the Agreement Date is as
              follows:
              <ol>
                <li class='tc-roman-li2'>
                  $62.50 per hour for non-university centres for Teaching Hours by a
                  Junior Teacher (less than 18 months’ experience), and $40.00 per hour for{' '}
                  <strong>Non-teaching Duties</strong>;
                </li>
                <li class='tc-roman-li2'>
                  $67.50 per hour for non-university centres for Teaching Hours by a
                  Senior Teacher (greater than 18 months’ experience), and $40.00 per hour for Non-teaching Duties;
                </li>
                <li class='tc-roman-li2'>
                  $115 per hour for university centres, and
                  $70.00 per hour for Non-teaching Duties (Day Rate available).
                </li>
                <li class='tc-roman-li2'>
                  Online teaching is charged at the Junior Rate specified in item 8.1 (i).
                </li>
              </ol>
            </li>
            <li>
              The Education Professional’s Rate <strong>(VET rate)</strong> for Vocational Education Trainers/Assessors
              in Australia as at the Agreement Date is as follows:
              <ol>
                <li class='tc-roman-li2'>
                  $62.50 per hour for non-university centres for Teaching Hours by a
                  Junior Teacher (less than 18 months’ experience), and $40.00 per hour
                  for <strong>Non-teaching Duties</strong>;
                </li>
                <li class='tc-roman-li2'>
                  $67.50 per hour for non-university centres for Teaching Hours by a
                  Senior Teacher (greater than 18 months’ experience), and $40.00 per hour for Non-teaching Duties;
                </li>
              </ol>
            </li>
            <li>
              The Education Provider shall pay Emergency and Extended Placement
              Fees for each Placement which shall include:
              <ol>
                <li class='tc-roman-li2'>
                  The Education Professional’s Rate (plus GST effective 1 July
                  2016) for each hour that an Education Professional attends a
                  Placement; plus
                </li>
                <li class='tc-roman-li2'>
                  Superannuation calculated at 10% of 90% of the Education
                  Professional’s Rate for each hour that an Education
                  Professional attends a Placement, for Australia-based
                  Education Providers only.
                </li>
              </ol>
            </li>
            <li>
              Refer to ReadyTeacher’s Services Agreement for all related details including terms and fees.
            </li>
            <li>
              The Invoice Date must occur on a weekly or fortnightly basis.
            </li>
            <li>
              The Education Provider agrees to pay any Tax Invoice within{' '}
              <strong>7 Calendar Days</strong> of the Invoice Date, unless:
              <ol>
                <li class='tc-roman-li2'>
                  Agreed otherwise between the parties;
                </li>
                <li class='tc-roman-li2'>
                  Otherwise specified on the Tax Invoice.
                </li>
              </ol>
            </li>
            <li>
              Payment shall be by electronic transfer into ReadyTeacher’s
              nominated bank account, or by Credit Card, or Direct Debit, or as
              otherwise directed by ReadyTeacher.
            </li>
          </ol>
        </p>
        <h4>
          <li>
            <strong>TERMINATION OF AGREEMENT</strong>
          </li>
        </h4>
        <p>
          <ol>
            <li>
              ReadyTeacher may immediately <strong>terminate</strong> this
              agreement in the event that;
              <ol>
                <li>
                  The Education Provider is disqualified from providing
                  education services by:
                  <ol>
                    <li class='tc-roman-li2'>
                      Australian Skills Quality Authority;
                    </li>
                    <li class='tc-roman-li2'>
                      The Department of Education; or
                    </li>
                    <li class='tc-roman-li2'>
                      Any other Government or regulatory body with the power to
                      do so.
                    </li>
                  </ol>
                </li>
                <li>
                  The Education Provider is repeatedly late in settling payment
                  for services provided.
                </li>
                <li>
                  The Education Provider behaves towards ReadyTeacher Education
                  Professionals (Contractors) or Employees in a manner that
                  reflects Workplace Discrimination or unfair treatment of any
                  kind. This includes discrimination towards Education
                  Professionals who are non-native speakers of English.
                </li>
              </ol>
            </li>
          </ol>
        </p>
      </ol>
      <br />
      <div className='row mt-5'>
        <div className='col-md-6 mb-2 mb-md-0'>
          <CancelButton onClick={props.onCancel}>Cancel</CancelButton>
        </div>
        <div className='col-md-6'>
          <ConfirmButton onClick={props.onConfirm}>Accept</ConfirmButton>
        </div>
      </div>
    </Modal>
  );
}

export default TermsAndConditionsCollege;
